import { ProfileProps } from '../profile'
import { ContractsStore } from '@/shared/model/store/contracts-store'
import useNotifier, { createCalls } from '@/shared/lib/use-notifier'
import { ConfigStore, LangStore } from '@/shared/model/store'
import { UserCard, UserStore } from '@/entities/user'
import { Button, Dialog, DialogContent, DialogTitle, DialogTrigger } from '@/shared/ui'
import { IUser } from '@/entities/user/model/types'
import { RefreshCw } from 'lucide-react'
import { useEffect, useState } from 'react'
import useRequest from '@/shared/lib/use-request'
import { IFollowers } from './following'

const FollowNPOButton = ({ profile, getUserFetch }: ProfileProps) => {
	const { contracts } = ContractsStore()
	const { domain } = ConfigStore()
	const { user_npos } = UserStore()
	const { langPack } = LangStore()

	const {
		fetch: fetchFollowers,
		result: followersResult,
		isLoading: isLoadingFollowers
	} = useRequest<IFollowers[]>('getFollowers')

	const [isOpen, setIsOpen] = useState(false)

	const filtred = user_npos?.filter((el: IUser) => el.address !== profile.address)

	const { writeContractMulticall: writeFollow } = useNotifier({
		onSuccess() {
			getUserFetch && getUserFetch()
			setIsOpen(false)
		}
	})

	const subscribe = async (addr: string) => {
		const isSubscribed = followersResult?.find((f: IFollowers) => f.user.address === addr)

		const call = {
			address: contracts.ContentRegistry.address,
			abi: contracts.ContentRegistry.abi,
			functionName: 'command',
			args: [domain, isSubscribed ? 'unfollow' : 'follow', addr, '', '', '']
		}
		const calls = createCalls([call])
		writeFollow(addr, calls)
	}

	useEffect(() => {
		if (!isOpen) return
		fetchFollowers({
			params: {
				domain: domain,
				user_addr: profile.address,
				limit: 1000,
				offset: '0'
			}
		})
	}, [isOpen])

	if (!user_npos || user_npos?.length === 0) return <></>

	return (
		<Dialog open={isOpen} onOpenChange={setIsOpen}>
			<DialogTrigger asChild>
				<Button variant={'secondary'} size={'sm'}>
					{langPack('profile.follow') + ' ' + langPack('npo.onBehalfOfNpo')}
				</Button>
			</DialogTrigger>
			<DialogContent>
				<DialogTitle>{langPack('npo.selectNpo')}</DialogTitle>
				<div className='flex flex-col gap-4'>
					{filtred.map((el: IUser) => (
						<div className='flex w-full items-center justify-between' key={el.address}>
							<UserCard key={el.address} user={el} />
							<Button
								onClick={() => {
									subscribe(el.address)
								}}
								size={isLoadingFollowers ? 'icon' : 'default'}
								variant='default'
							>
								{isLoadingFollowers ? (
									<RefreshCw className='h-4 w-4 animate-spin' />
								) : followersResult?.find((f: IFollowers) => f.user.address === el.address) ? (
									langPack('profile.unfollow')
								) : (
									langPack('profile.follow')
								)}
							</Button>
						</div>
					))}
				</div>
			</DialogContent>
		</Dialog>
	)
}

export default FollowNPOButton
